/**
 * 操作マニュアルの URL
 * - 実体は public/manuals/ の静的サイトで、フロントエンドと同じ CloudFront から配信する
 * - /manuals/* は CloudFront Function で会社ごとの共通 ID・パスワード（Basic 認証）を検証する（#4149、copilot/frontend/manual-auth）
 */
export const MANUAL_SITE_URL = '/manuals/'
